export default "__VITE_ASSET__D8oQvI4r__"